import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

const Portal: React.FunctionComponent = props => {
    const el = useRef(document.createElement('div'));

    useEffect(() => {
        document.body.appendChild(el.current);
        return () => {
            document.body.removeChild(el.current);
        };
    }, []);

    return ReactDOM.createPortal(props.children, el.current);
};

export default Portal;
